import { render, staticRenderFns } from "./GatewaysCPay.vue?vue&type=template&id=5b2659fb&"
import script from "./GatewaysCPay.vue?vue&type=script&lang=js&"
export * from "./GatewaysCPay.vue?vue&type=script&lang=js&"
import style0 from "./GatewaysCPay.vue?vue&type=style&index=0&id=5b2659fb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports